import { useQuery, UseQueryResult } from 'react-query';
import { getApplicationStatus, Applications } from '../../services/getApplicationStatus';
import { handleUnauthorizedError } from '../../services/queryClient';
import { dispatchGetApplicationStatusErrorEvent } from '../../utils/analyticsEvents/requestEvents';
import { ReactQueryKeys } from './keys';

const useGetApplicationStatus = (): UseQueryResult<Applications, Error> =>
  useQuery(ReactQueryKeys.GET_APPLICATION_STATUS, getApplicationStatus, {
    onError: (error: Error): void => {
      dispatchGetApplicationStatusErrorEvent(error.message);
      handleUnauthorizedError(error);
    },
  });

export { useGetApplicationStatus };
